import React from "react";
import api from "../../utils/api";

type GstReportData = {
    totalGst: number;
    thisMonthGst: number;
    todayGst: number;
};

const GstReport: React.FC = () => {
    const [gstData, setGstData] = React.useState<GstReportData>({
        totalGst: 0,
        thisMonthGst: 0,
        todayGst: 0,
    });
    const fetchData = async () => {
        const response = await api.get('/api/GstReport/GstReport');
        if (response.status === 200) {
            const data = response.data;
            setGstData({
                totalGst: data.totalGst || 0,
                thisMonthGst: data.monthlyGst || 0,
                todayGst: data.todayGst || 0,
            });
        }
    };
    React.useEffect(() => {
        fetchData();
    }, []);

    const cardDetails = [
        {
            label: "Total GST",
            value: gstData.totalGst,
            icon: <i className="fas fa-rupee-sign fs-2 text-primary"></i>,
            color: "#e3f2fd",
        },
        {
            label: "Monthly GST",
            value: gstData.thisMonthGst,
            icon: <i className="fas fa-calendar-alt fs-2 text-secondary"></i>,
            color: "#fce4ec",
        },
        {
            label: "Today",
            value: gstData.todayGst,
            icon: <i className="fas fa-calendar-day fs-2 text-success"></i>,
            color: "#e8f5e9",
        },
    ];
    return (
        <div className='page-body'>
            <div className="container py-4">
                <h5 className="mb-4">GST Report</h5>
                <div className="row g-4">
                    {cardDetails.map((card) => (
                        <div className="col-12 col-sm-6 col-md-4" key={card.label}>
                            <div
                                className="card shadow-sm"
                                style={{ minWidth: 220, background: card.color }}
                            >
                                <div className="card-body">
                                    <div className="d-flex align-items-center mb-3">
                                        <span>{card.icon}</span>
                                        <span className="ms-3 h6 mb-0">{card.label}</span>
                                    </div>
                                    <div className="h4 fw-bold">
                                        ₹ {card.value.toLocaleString()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default GstReport;